<div class="modal-header justify-content-between">
  <h4>Logo Manager</h4>
  <button class="btn btn-link" (click)="cancel()"><i class="bi bi-x-lg"></i></button>
</div>

<div class="modal-body">
  <!-- Add new logo -->
  <div class="card mb-3">
    <div class="card-header"><strong>Add New Logo</strong></div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-auto d-flex align-items-center">
            <label>Name:</label>
        </div>
        <div class="col d-flex align-items-center">
            <input class="form-control" placeholder="Logo Name" [(ngModel)]="addName">
        </div>
        <div class="col-auto d-flex align-items-center">
            <label>Image:</label>
        </div>
        <div class="col d-flex align-items-center">
            <input type="file" class="form-control" (change)="onAddFileSelected($event)">
        </div>
        <div class="col-auto d-flex align-items-center">
            <button class="btn btn-primary" (click)="addLogo()" [disabled]="!addName || !addFile || uploading">
                Add Logo
            </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Existing logos -->
  <div class="table-responsive" style="max-height: 30vh; overflow-y: auto;">
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th>Preview</th>
          <th>Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let logo of logos">
          <td>
            <img [src]="logosBaseUrl + '/' + logo.name" alt="{{logo.name}}" style="max-height:50px">
          </td>
          <td>{{ logo.name }}</td>
          <td>
            <label class="btn btn-sm btn-outline-secondary me-1 mb-0">
              Update <input type="file" hidden (change)="updateLogo(logo, $event)">
            </label>
            <button class="btn btn-sm btn-outline-danger" (click)="deleteLogo(logo)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-light" (click)="cancel()">Close</button>
</div>